import { render, staticRenderFns } from "./RoyaltyAnalytics.vue?vue&type=template&id=27329d66&scoped=true&"
import script from "./RoyaltyAnalytics.vue?vue&type=script&lang=js&"
export * from "./RoyaltyAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./RoyaltyAnalytics.vue?vue&type=style&index=0&id=27329d66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27329d66",
  null
  
)

export default component.exports